<template>
  <div>
    <p
      id="achieve-title"
      :style="isRtl ? 'font-size: 36px' : 'font-size: 30px'"
    >
      {{ $t('My Companies') }}
    </p>
    <div class="card-row">
      <div class="col achieve-card" v-for="(x, index) in list" :key="index">
        <img class="the-logo" :src="getImage(x.logo)" alt="Logo" />
        <h3 :style="isRtl ? 'font-size: 24px;' : 'font-size: 22px'">
          {{ $t(x.title) }}
        </h3>
        <p
          :style="isRtl ? 'font-size: 18px;' : 'font-size: 16px'"
          class="card-text"
        >
          {{ $t(x.text) }}
        </p>
        <div class="visit-link">
          <a style="text-decoration: none" :href="x.link" target="blank">{{
            $t('Visit website')
          }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      list: [
        {
          logo: 'mirka_group_logo.jpg',
          title: 'Mirka Group',
          link: 'https://mirkagroup.com/',
          text:
            'Mirka group consists of many companies working in different sectors, with a professional staff and expert employees working, Mirka sectors consist of (Mirka travel, Mirka Tech, Mirka Cars, Mirka legal, Mirka Transport). '
        },
        {
          logo: 'mirkatravel_logo.jpg',
          title: 'Mirka Travel',
          link: 'https://mirkatravel.com/',
          text:
            'Mirka Travel is one of the greatest companies in the travel and tourism industry based in Sulaymaniyah that has more than 18 years of experience.'
        },
        {
          logo: 'mirkatech_logo.jpg',
          title: 'Mirka Tech',
          link: 'https://mirkatech.com/',
          text:
            'Mirka Tech is an information technology company based in Sulaimanyiah - Iraq, we are specialized (web development, Mobile application, Database management system, network services and social media management).'
        },
        {
          logo: 'mirkacars_logo.jpg',
          link: 'http://mirkacars.com/',
          title: 'Mirka Cars',
          text:
            'Mirka Cars is the cars industry companies which works on importing cars and cars peaces.'
        },
        {
          logo: 'kurdcell-logo.webp',
          link: 'https://kurdcell.tv/',
          title: 'Kurd Cell',
          text:
            'Kurdcell is a technology-driven company specializing in providing devices that allow users to easily access and enjoy local TV channels. Founded in 2022, we are dedicated to delivering simple, affordable, and high-quality solutions that bring local entertainment to every home. Our mission is to bridge the gap between technology and accessibility, ensuring everyone can stay informed and entertained — wherever they are.'
        },
        {
          logo: 'mirka-pertroleum.webp',
          link: 'https://mirkapetroleum.ae/',
          title: 'Mirka Petroleum',
          text:
            'Mirka Oil Company is a general trading & oilfield service company From UAE Established in 2023. we are quality oriented with high numbers of professional experience in construction, supply and logistics. For us customer satisfaction is on top of our company agendas, and it is what had brought us here, bigger, better, and trust worthier than ever.'
        },
        {
          logo: 'rukhsary-altwny.webp',
          link: 'https://rukhsaryaltuny.com/',
          title: 'Rukhsary Altuny',
          text:
            'Rukhsary Altuny Company is a property development and investment company based in Iraq, established in 2023. We deliver high-quality residential and commercial projects with a focus on trust, innovation, and customer satisfaction — values that have made us one of Iraq’s trusted real estate partners.'
        },
        {
          logo: 'mirka-adventure.webp',
          link: 'https://mirkaadventure.com/',
          title: 'Mirka Adventure',
          text:
            'Mirka Adventure is a travel and adventure company based in Kurdistan, offering hiking tours, wildlife experiences, and group adventures across the region. We are passionate about nature, culture, and exploration — creating unforgettable journeys that connect people with the wild beauty of Kurdistan.'
        }
      ]
    }
  },

  computed: {
    ...mapGetters({
      isRtl: 'getRtl'
    })
  },

  methods: {
    getImage(imgName) {
      return require(`../assets/${imgName}`)
    }
  }
}
</script>

<style lang="scss">
$secondaryColor: #e01e37;
$primaryColor: #38285a;
$backgroundColor: #e1e5e8;

.visit-link {
  padding: 6px 10px;
  border-radius: 4px;
  position: absolute;
  bottom: 10px;
  border: 1px solid $secondaryColor;
  transition: all 0.3s;
  right: 50%;
  transform: translateX(50%);
}
.visit-link:hover {
  background: $secondaryColor;
}

.visit-link:hover > a {
  color: #fff;
}
.visit-link > a {
  color: $secondaryColor;
}
#my-achievement {
  position: relative;
  background-color: #fff;
  padding: 100px 70px;
}

#achieve-title {
  text-align: center;
  padding-bottom: 50px;
  margin-top: 0px;
}

.card-row {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: auto;
  padding-top: 10px;
}
.col {
  width: 40%;
}
.achieve-card {
  padding: 10px 20px 40px 20px;
  border-radius: 4px;
  border: 1px solid $backgroundColor;
  margin-bottom: 40px;
  text-align: center;
  position: relative;
}
.achieve-card:hover {
  box-shadow: 1px 0px 16px 0 rgba(0, 0, 0, 0.09),
    -8px -8px 16px 0 rgba(255, 255, 255, 0.09);
  transition: all 0.3s;
}
.card-text {
  line-height: 1.5;
}
.the-logo {
  width: 100%;
  height: 200px;
  object-fit: contain;
}
</style>
